import React from "react";
import { withTranslation } from "react-i18next";
import { Icon } from "semantic-ui-react";

import "./index.scss";

const Legend = ({ t }) => (
  <div className="interventions-legend">
    <span className="legend-title">{t("cc_legend").message || "Legend"}</span>
    <span className="interventions-legend-item">
      <Icon name="circle times" className="interventions-legend-icon interventions-legend-icon--red" />
      <span className="intervention-legend-item-description">{t("cc_not_approved").message || "Not Approved"}</span>
    </span>
    <span className="interventions-legend-item">
      <Icon name="circle check" className="interventions-legend-icon interventions-legend-icon--green" />
      <span className="intervention-legend-item-description">{t("cc_approved_legend").message || "Approved"}</span>
    </span>
    <span className="interventions-legend-item">
      <Icon name="wrench" className="interventions-legend-icon interventions-legend-icon--tool--red rotate-270" />
      <span className="intervention-legend-item-description">{t("cc_not_fixed").message || "Not Fixed"}</span>
    </span>
    <span className="interventions-legend-item">
      <Icon name="wrench" className="interventions-legend-icon rotate-270" />
      <span className="intervention-legend-item-description">{t("cc_fix_pending").message || "Fix pending"}</span>
    </span>
    <span className="interventions-legend-item">
      <span className="mechanic-fixed-status-container">
        <Icon name="wrench" className="interventions-legend-icon interventions-legend-icon--green" />
        <Icon name="check circle" className="interventions-legend-icon interventions-legend-icon--green wrench-check-icon" />
      </span>
      <span className="intervention-legend-item-description">{t("cc_fixed").message || "Fixed"}</span>
    </span>
  </div>
);

export default withTranslation()(Legend);
